<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><rect width="16" height="16" rx="8" style="fill:#2c59d9"/><path d="M.91 12h1.4V9.03c0-.85-.11-1.78-.18-2.58h.05l.75 1.59L5.07 12h1.5V4.6h-1.4v2.95c0 .84.11 1.82.19 2.59h-.05l-.74-1.6L2.42 4.6H.91z" style="fill:#fff" transform="translate(4)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-badge-new',
});
</script>
